import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
	selector: 'app-modal-idle',
	templateUrl: './modal-idle.component.html',
	styleUrls: ['./modal-idle.component.css']
})
export class ModalIdleComponent implements OnInit, OnDestroy {

	public countdown: number;
	private countdownInterval;
	constructor(
		public dialogRef: MatDialogRef<ModalIdleComponent>
	) { }

	startCounddown() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
		this.countdownInterval = setInterval(() => {
			if (this.countdown > 0) {
				this.countdown--;
			} else {
				this.dialogRef.close('leave');
			}
		}, 1000);
	}
	ngOnInit() {
		this.countdown = 30;
		this.startCounddown();
	}
	ngOnDestroy() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/modal-idle/modal-idle.component.ts